export const IconYoutube = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_65_18799)">
        <path d="M16.3357 6.71464C16.2724 6.46631 16.0924 6.27881 15.8866 6.22131C15.5224 6.11881 13.7474 5.88548 9.9974 5.88548C6.2474 5.88548 4.47406 6.11881 4.10656 6.22131C3.90323 6.27798 3.72323 6.46548 3.65906 6.71464C3.56823 7.06798 3.33073 8.54881 3.33073 10.8855C3.33073 13.2221 3.56823 14.7021 3.65906 15.0571C3.7224 15.3046 3.9024 15.4921 4.1074 15.5488C4.47406 15.6521 6.2474 15.8855 9.9974 15.8855C13.7474 15.8855 15.5216 15.6521 15.8882 15.5496C16.0916 15.493 16.2716 15.3055 16.3357 15.0563C16.4266 14.703 16.6641 13.2188 16.6641 10.8855C16.6641 8.55214 16.4266 7.06881 16.3357 6.71464ZM17.9499 6.30048C18.3307 7.78548 18.3307 10.8855 18.3307 10.8855C18.3307 10.8855 18.3307 13.9855 17.9499 15.4705C17.7382 16.2913 17.1191 16.9371 16.3349 17.1555C14.9107 17.5521 9.9974 17.5521 9.9974 17.5521C9.9974 17.5521 5.08656 17.5521 3.6599 17.1555C2.8724 16.9338 2.25406 16.2888 2.0449 15.4705C1.66406 13.9855 1.66406 10.8855 1.66406 10.8855C1.66406 10.8855 1.66406 7.78548 2.0449 6.30048C2.25656 5.47964 2.87573 4.83381 3.6599 4.61548C5.08656 4.21881 9.9974 4.21881 9.9974 4.21881C9.9974 4.21881 14.9107 4.21881 16.3349 4.61548C17.1224 4.83714 17.7407 5.48214 17.9499 6.30048ZM8.33073 13.8021V7.96881L13.3307 10.8855L8.33073 13.8021Z" fill="#979797"/>
      </g>
      <defs>
        <clipPath id="clip0_65_18799">
          <rect width="20" height="20" fill="white" transform="translate(0 0.885498)"/>
        </clipPath>
      </defs>
    </svg>
  );
};